class CM1ProductGrid extends HTMLElement {
  constructor () {
    super()

    this.totalPageSize = this.dataset.totalItems
    this.preRenderedPromos = document.querySelectorAll('[data-promo-position]')
    this.productGrid = this.querySelector('#product-grid')
  }

  connectedCallback () {
    this.insertPromos()
  }

  insertPromos () {
    const searchParams = new URLSearchParams(window.location.search)
    const activeFacets = []
    let currentPage = 1

    searchParams.forEach((value, key) => {
      const values = value.includes(',') ? value.split(',') : [value]
      switch (key) {
        case 'sort_by':
          break
        case 'phcursor':
          break
        case 'page':
          currentPage = parseInt(value, 10)
          break
        default:
          if (key !== 'page') {
            activeFacets.push({ field: key, value: values })
          }
      }
    })

    if (!this.productGrid || this.preRenderedPromos.length === 0 || activeFacets.length > 0) {
      return
    }

    // Parse promo data from JSON script
    const promoScript = document.querySelector('script[data-bambuser-promos]')
    if (!promoScript) {
      return
    }

    let promoData
    try {
      promoData = JSON.parse(promoScript.textContent)
    } catch (error) {
      console.error('Failed to parse promo data:', error)
      return
    }

    // Sort promos by position (ascending) to insert from beginning to end
    const sortedPromos = promoData.sort((a, b) => a.position - b.position)

    const topEnd = currentPage * this.totalPageSize
    const bottomEnd = topEnd - this.totalPageSize

    sortedPromos.forEach(promo => {
      const preRenderedPromo = document.querySelector(`[data-promo-position="${promo.position}"]`)

      // Calculate target index (0-based position)
      let targetIndex = promo.position - 1

      if (!preRenderedPromo || targetIndex < bottomEnd || targetIndex > topEnd) {
        return
      }

      // Create new li element for the promo
      const promoListItem = document.createElement('li')
      promoListItem.className = 'vbf-product-grid__item vbf-product-grid__item--promo'

      // Handle column spanning
      const columnSpan = promo.column_span || 1

      // Check if the viewport width is less than 768px
      const isMobile = window.matchMedia('(max-width: 767px)').matches

      if (isMobile) {
        promoListItem.style.gridColumn = `span 2`
      } else {
        promoListItem.style.gridColumn = `span ${columnSpan}`
      }

      // Extract the hero card content without the wrapper div
      Array.from(preRenderedPromo.children).forEach(child => {
        const clonedChild = child.cloneNode(true)

        // If Styltitics promo then create new id attribute value
        if (clonedChild.querySelector('[data-stylitics-container-id*="stylitics-composer-container-"]')) {
          const child = clonedChild.querySelector('[data-stylitics-container-id*="stylitics-composer-container-"]')
          child.id = child.id = child.dataset.styliticsContainerId // change the id
        }

        promoListItem.appendChild(clonedChild)
      })

      if (currentPage > 1) {
        targetIndex = targetIndex - ((currentPage - 1) * this.totalPageSize)
      }

      const elementAtIndex = this.productGrid.children[targetIndex]

      if (elementAtIndex) {
        // Insert before the element at target position
        this.productGrid.insertBefore(promoListItem, elementAtIndex)
      } else {
        // Insert at the end if position is beyond current items
        this.productGrid.appendChild(promoListItem)
      }
    })
  }
}

customElements.define('cm1-product-grid', CM1ProductGrid)
